import React, { useContext } from 'react';
import { useDispatch } from 'react-redux';
import { Menu, Icon } from 'semantic-ui-react';
import { SettingMenuContext } from './content';
import { redirectToInternalLink } from 'businessLogic/redirector';
import { getCallQualityProfiles } from 'actions/portalSetting';
import { resetMeetingRoomForm } from 'actions/meetingRoom';
import {
  selectMeetingRoom,
  updateMeetingRoomForm,
  getLastTimeMeetingRoomUsed,
  getMeetingRoomDetails,
} from 'actions/meetingRoom.js';
import {
  // Meeting Room modals
  showResetGuestLinkModal,
  showEditMeetingRoomModal,
  updateShowDeleteMeetingRoomModal,
} from 'actions/modal';
import { updateFilterValue } from 'actions/organisation';

// MR setting menu
function resetGuestLink(room, dispatch) {
  dispatch(updateMeetingRoomForm(room));
  dispatch(showResetGuestLinkModal(true));
}

function getMeetingRoom(room, dispatch) {
  let cb = (data) => {
    let postCallOption = room.postCallOption && room.postCallOption > 0 ? room.postCallOption : 0;
    let editMeetingRoomPayload = {
      id: room.id || '',
      name: room.name || '',
      videoCallQualityId: room.videoCallQualityId || 0,
      organisationNetworkId: room.organisationNetworkId || 0,
      postCallUrl: room.postCallUrl || '',
      callProviderUrl: room.callProviderUrl || '',
      callerGuestUrl: room.callerGuestUrl || '',
      postCallOption: postCallOption,
    };
    dispatch(updateMeetingRoomForm(editMeetingRoomPayload));
    dispatch(showEditMeetingRoomModal(true));
  };
  dispatch(getCallQualityProfiles(cb));
}

function manageMeegingRoomUsers(room, filterValue, dispatch) {
  dispatch(updateFilterValue(filterValue));
  redirectToInternalLink('meeting-room/manage-users/' + room.id);
}

function deleteMeetingRoom(room, dispatch) {
  let cb = () => {
    //call show delete func
    dispatch(updateShowDeleteMeetingRoomModal(true));
  };

  dispatch(updateMeetingRoomForm(room));
  dispatch(getLastTimeMeetingRoomUsed(room.id, cb));
}

// MR setting menu
export default function MRSettingMenu(props) {
  const dispatch = useDispatch();
  const { mrSetting, selectedMeetingRoom, entityFilter, openSubMenu } = useContext(SettingMenuContext);
  const [openMRSettingMenu, setOpenMRSettingMenu] = mrSetting;
  const [settingSubMenuActiveIndex, setSettingSubMenuActiveIndex] = openSubMenu;
  const [filterValue, setFilterValue] = entityFilter;

  let hasManageMeetingRoomAccess = false;
  let hasEditMeetingRoomAccess = false;
  let hasViewMeetingRoomAccess = false;
  let hasManageRolesAccess = false;
  let hasViewTagsAccess = false;

  if (selectedMeetingRoom && selectedMeetingRoom.permissions && selectedMeetingRoom.permissions.length > 0) {
    hasManageMeetingRoomAccess = selectedMeetingRoom.permissions.indexOf('MANAGE_ACCESS') > -1;
    hasEditMeetingRoomAccess = selectedMeetingRoom.permissions.indexOf('EDIT') > -1;
    hasViewMeetingRoomAccess = selectedMeetingRoom.permissions.indexOf('VIEW') > -1;
    hasManageRolesAccess = selectedMeetingRoom.permissions.indexOf('MANAGE_MEMBER_ROLES') > -1;
    hasViewTagsAccess =
      selectedMeetingRoom.reportingTagsEnabled && selectedMeetingRoom.permissions.indexOf('VIEW_ASSIGNED_TAGS') > -1;
  }

  return (
    <React.Fragment>
      {openMRSettingMenu && (
        <div id="entity-admin-setting-menu" className="advanced-settings">
          <Menu className="new-advanced-settings-menu color-meeting-room-bg pdbnull" vertical>
            <Menu.Header
              className={
                'inline-flex center-flex pdtm pdbm space-between max-width ' +
                (props.isOnMobileOrTablet ? 'pdlm pdrm pdtm pdbm' : 'pdll pdrml')
              }
            >
              <div>
                <div className="color-white mrrs mrbxxs">{APP.LANGUAGE.EntityAdmin.MeetingRoom}</div>
                <div className="color-white bold mrrs setting-menu-header wrap-link">
                  {APP.LANGUAGE.EntityAdmin.Settings.replace('##entityName##', selectedMeetingRoom.name)}
                </div>
              </div>
              {props.isOnMobileOrTablet ? (
                <div className="pdxs hand" onClick={props.closeMenu}>
                  <Icon name="cancel" className="color-footer-links mrrnull close-menu-icon" size="large" />
                </div>
              ) : (
                <div style={{ width: '38px', height: '40px' }} />
              )}
            </Menu.Header>
            {hasViewMeetingRoomAccess && hasEditMeetingRoomAccess && (
              <Menu.Item
                className={
                  props.isOnMobileOrTablet ? 'standard-menu-font-size pdlm pdrm pdtm pdbm' : 'standard-menu-font-size'
                }
                onClick={() => {
                  resetGuestLink(selectedMeetingRoom, dispatch);
                }}
              >
                {APP.LANGUAGE.ViewMeetingRoom.ResetGuestLink}
              </Menu.Item>
            )}
            {hasViewMeetingRoomAccess && hasEditMeetingRoomAccess && (
              <Menu.Item
                className={
                  props.isOnMobileOrTablet ? 'standard-menu-font-size pdlm pdrm pdtm pdbm' : 'standard-menu-font-size'
                }
                onClick={() => {
                  getMeetingRoom(selectedMeetingRoom, dispatch);
                }}
              >
                {APP.LANGUAGE.ViewMeetingRoom.EditAction}
              </Menu.Item>
            )}
            {hasManageRolesAccess && (
              <Menu.Item
                className={
                  props.isOnMobileOrTablet ? 'standard-menu-font-size pdlm pdrm pdtm pdbm' : 'standard-menu-font-size'
                }
                onClick={() => {
                  manageMeegingRoomUsers(selectedMeetingRoom, filterValue, dispatch);
                }}
              >
                {APP.LANGUAGE.ViewMeetingRoom.ManageUserAction}
              </Menu.Item>
            )}
            {hasViewMeetingRoomAccess && hasEditMeetingRoomAccess && (
              <Menu.Item
                className={
                  props.isOnMobileOrTablet ? 'standard-menu-font-size pdlm pdrm pdtm pdbm' : 'standard-menu-font-size'
                }
                onClick={() => {
                  deleteMeetingRoom(selectedMeetingRoom, dispatch);
                }}
                disabled={!(selectedMeetingRoom.participants && selectedMeetingRoom.participants.length == 0)}
              >
                {selectedMeetingRoom.participants && selectedMeetingRoom.participants.length == 0
                  ? APP.LANGUAGE.ViewMeetingRoom.DeleteAction
                  : APP.LANGUAGE.ViewMeetingRoom.DeleteAction.replace('...', ' (Currently in use)...')}
              </Menu.Item>
            )}
          </Menu>
        </div>
      )}
    </React.Fragment>
  );
}
